<script>
  import Button from "./Button.svelte"
  export let buttonsValues = []
</script>

<div class="buttons">
  {#each buttonsValues as buttonValue}
    <Button {buttonValue} on:handleClick />
  {/each}
</div>

<style>
  .buttons {
    display: flex;
    justify-content: space-evenly;
  }
</style>